import { fnv1aHash } from './fnv1a-hash';

export function pseudonymize(username: string, salt = 'weave-username-v1::'): string {
  const salted = salt + username;
  // fnv1aHash is synchronous and generates a hash that's good enough for pseudonymization
  const hash = fnv1aHash(salted);
  return hash.toString(16); // Hex output
}
